import React from "react";
import SeletorLoja from "./components/SeletorLoja";
import AppState from "./model/AppState";
import Rodape from "./components/Rodape";
import BuscaProdutos from "./components/BuscaProdutos";
import MockData from "./model/MockData";
import ConteudoModel from "./model/ConteudoModel";
import ProdutoModel from "./model/ProdutoModel";
import ReactDOM from "react-dom";
import PaginaTitulo from "./components/PaginaTitulo";
import ListaItens from "./components/ListaItens";
import QueryString from "query-string";
import C5CategoriaDAO from "./dataAccess/C5/C5CategoriaDAO";
import LojaModel from "./model/LojaModel";
import LogUtil from "./util/LogUtil";
import NavegadorUtil from "./util/NavegadorUtil";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface ICategoriaInternaProps extends RouteComponentProps {}

type CategoriaInternaState = {
  nome: string;
  sub: string;
  produtos: ProdutoModel[];
  conteudos: ConteudoModel[];
  carregando: boolean;
  concluido: boolean;
};

class CategoriaInterna extends React.Component<
  ICategoriaInternaProps,
  CategoriaInternaState
> {
  constructor(props: ICategoriaInternaProps) {
    super(props);

    this.showProdutos = this.showProdutos.bind(this);
    this.showConteudos = this.showConteudos.bind(this);

    this.state = {
      nome: "",
      sub: "",
      produtos: [],
      conteudos: [],
      carregando: true,
      concluido: false,
    };
  }

  showProdutos(): any {
    const prods: any = this.refs.btnProds;
    const conts: any = this.refs.btnConts;

    if (prods) {
      prods.classList.remove("active");
      prods.classList.add("active");
    }

    if (conts) {
      conts.classList.remove("active");
    }

    const prodsContainer: any = ReactDOM.findDOMNode(this.refs.prods);
    const contsContainer: any = ReactDOM.findDOMNode(this.refs.conts);
    prodsContainer.style.display = "block";
    contsContainer.style.display = "none";
  }

  showConteudos(): any {
    const prods: any = this.refs.btnProds;
    const conts: any = this.refs.btnConts;
    if (prods) {
      prods.classList.remove("active");
    }

    if (conts) {
      conts.classList.remove("active");
      conts.classList.add("active");
    }

    const prodsContainer: any = ReactDOM.findDOMNode(this.refs.prods);
    const contsContainer: any = ReactDOM.findDOMNode(this.refs.conts);
    prodsContainer.style.display = "none";
    contsContainer.style.display = "block";
  }

  componentDidUpdate(): void {
    if (this.state.produtos.length === 0) {
      this.showConteudos();
    } else {
      this.showProdutos();
    }
  }

  componentDidMount(): void {
    LogUtil.logPage("Categoria - interna");
    let query: any;
    query = QueryString.parse(this.props.location.search);
    const loja: LojaModel | null = AppState.getLojaSelecionada();

    if (query.nome) {
      this.setState({
        nome: query.nome,
      });
    }

    if (query.sub) {
      this.setState({
        sub: query.sub,
      });
    }

    if (loja) {
      if (AppState.getMockData()) {
        this.setState({
          produtos: MockData.getProdutos(),
          conteudos: MockData.getConteudos(),
          carregando: false,
          concluido: true,
        });
      } else {
        C5CategoriaDAO.getInstance()
          .getTerceiroNivelProdutos(
            query.catId,
            query.subcatId,
            query.subsubcatId,
            loja.lojaId
          )
          .then((prod: ProdutoModel[]) => {
            this.setState({
              produtos: prod,
              carregando: false,
              concluido: true,
            });
          });
      }
    } else {
      NavegadorUtil.redirect("/lojas", this.props.history);
    }
  }

  render(): any {
    const { produtos, conteudos, nome, sub, carregando, concluido } = this.state;
    if (produtos || conteudos) {
      return (
        <section className="category has-footer">
          <SeletorLoja loja={AppState.getLojaSelecionada()}></SeletorLoja>
          <BuscaProdutos parent={this}></BuscaProdutos>
          <PaginaTitulo titulo={nome} subtitulo={sub}></PaginaTitulo>
          <ul className="main-menu">
            <li
              className="products active"
              onClick={this.showProdutos}
              ref="btnProds"
            >
              Produtos
            </li>
            <li className="inspire" onClick={this.showConteudos} ref="btnConts">
              <i className="far fa-heart"></i> Inspire-se
            </li>
          </ul>
          <div ref="prods">
            <ListaItens
              produtos={produtos}
              parent={this}
              carregando={carregando}
              concluido={concluido}
            ></ListaItens>
          </div>
          <div ref="conts">
            <ListaItens
              conteudos={conteudos}
              parent={this}
              carregando={carregando}
              concluido={concluido}
            ></ListaItens>
          </div>
          <Rodape parent={this} ativo=""></Rodape>
        </section>
      );
    }
  }
}

export default withRouter(CategoriaInterna);
